import { useMutation } from '@apollo/client';

import { UPDATE_MEALS } from 'store/mutations';

const useUpdateMealsMutation = ({ bookingReference, outbound, inbound, applySalesRestrictionOverrides = false }) => {
  const [updateMeals, { loading, error }] = useMutation(UPDATE_MEALS);

  const handleMutation = async () => {
    await updateMeals({
      variables: {
        bookingReference,
        outbound,
        inbound,
        applySalesRestrictionOverrides
      }
    });
  };

  return [handleMutation, { loading, error }];
};

export default useUpdateMealsMutation;
